module.exports = __webpack_public_path__ + "static/img/facebook.03c3adf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/social/facebook.png
// module id = 9gFH
// module chunks = 31